/**
 * Authentication hook that wraps the Zustand auth store
 * Provides a consistent interface for authentication state and actions
 */

import { useAuthStore } from '../store';

export const useAuth = () => {
  const { user, token, isAuthenticated, login, logout } = useAuthStore();

  return {
    user,
    token,
    isAuthenticated,
    login,
    logout,
  };
};
